export default [
  // layout
  {
    path: '/demo-uploadFile',
    component: () => import('../../views/demo/UploadFile.vue'),
    name: 'demo.uploadFile',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // layout
  {
    path: '/demo-adapter',
    component: () => import('../../views/demo/Adapter.vue'),
    name: 'demo.adapter',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // demo-slider-verify
  {
    path: '/demo-sliderVerify',
    component: () => import('../../views/demo/SliderVerify.vue'),
    name: 'demo.sliderVerify',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
];
